// Add this FIRST in your application boot sequence
(function () {
  if (typeof window !== 'undefined') {
    if (!('global' in window)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).global = window;
    }
    if (!('process' in window)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).process = { env: {} };
    }
  }
})();
